module.exports = __webpack_public_path__ + "img/switzerland-mental-and-behavioural-disorders-male.a71e7ed5.png";